import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import { useInventoryState } from '../../../../../hooks';
import { useRowState } from '../../../../../hooks/useRowState';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { RoomOpeningInventory } from '../../../../../utils/rooms';
import { CheckboxCell } from '../../../../Table/Cells/CheckboxCell/CheckboxCell';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';
import { isEnabledByMessage } from '../../../tabViewUtils';

const RoomForceUnpublishRowComponent: React.FC<{ roomId: number }> = ({
  roomId,
}) => {
  const { inventoryRooms, dateKeys } = useRowState(InventoryTabItemName.Rooms);
  const { endOfSaleDate } = useInventoryState();

  if (!inventoryRooms) {
    return null;
  }

  return (
    <TableRow>
      <LabelCell label="Force unpublish" />
      {dateKeys.map((dateKey) => {
        const roomFieldName = [dateKey, `${roomId}`];
        const forceUnpublishFieldName = [
          ...roomFieldName,
          'isClosedByStaycation',
        ];
        const isPast = isDatePast(dateKey);
        const isGrayed = isPast || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={roomFieldName} dateKey={dateKey}>
            {(values?: RoomOpeningInventory) => {
              const isDisabled = !isEnabledByMessage(values?.message) || isPast;

              return (
                <CheckboxCell
                  name={forceUnpublishFieldName}
                  disabled={isDisabled}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const RoomForceUnpublishRow = React.memo(RoomForceUnpublishRowComponent);
